import * as types from '../../mutation-types'
import lazyLoading from './lazyLoading'
// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'

// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    {
      name: 'Сценарии',
      path: '/scenarios',
      meta: {
        label: 'Сценарии',
        icon: 'fa-comments',
        link: 'scenarios/Scenarios.vue'
      },
      component: lazyLoading('scenario/Scenarios')
    },
    {
      name: 'Рассылки',
      path: '/campaigns',
      meta: {
        label: 'Рассылки',
        icon: 'fa-phone-square',
        link: 'campaigns/Campaigns.vue'
      },
      component: lazyLoading('campaigns/Campaigns')
    },
    {
      name: 'Архив рассылок',
      path: '/archive',
      meta: {
        label: 'Архив рассылок',
        icon: 'fas fa-archive',
        link: 'campaigns/Archive.vue'
      },
      component: lazyLoading('campaigns/Archive')
    },
    {
      name: 'Пользователи',
      path: '/users',
      meta: {
        label: 'Пользователи',
        icon: 'fa-user',
        link: 'users/Users.vue'
      },
      component: lazyLoading('users/Users')
    },
    {
      name: 'Клиенты',
      path: '/clients',
      meta: {
        label: 'Клиенты',
        icon: 'fa-building',
        link: 'clients/Clients.vue'
      },
      component: lazyLoading('clients/Clients')
    },
    {
      name: 'Настройка прав',
      path: '/permissions',
      meta: {
        label: 'Настройка прав',
        icon: 'fa-tasks',
        link: 'settings/Permissions.vue'
      },
      component: lazyLoading('settings/Permissions')
    },
    {
      name: 'Настройка приложения',
      path: '/appconfig',
      meta: {
        label: 'Настройка приложения',
        icon: 'fa-cogs',
        link: 'settings/AppConfig.vue'
      },
      component: lazyLoading('settings/AppConfig')
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js